import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";

export class MallNameField extends Field<string> {
  constructor(
    model: Merchant,
    fieldSetIndex: number,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "TestMall",
      propertyName: "mallName",
      uiFieldType: "Input",
      ...opts,
    });
    this.fieldSetIndex = fieldSetIndex;
  }

  public fieldSetIndex: number;

  get applicable(): boolean {
    const isMall = this._model.locations[this.fieldSetIndex]?.isMall?.value;
    return isMall === "Yes";
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
